// extracted by mini-css-extract-plugin
module.exports = {"box":"FJStockBox_box__2KOgh"};